import React, { useEffect, useState } from 'react';
import { api_url } from '../../Constants/web_services';
import Counter from './Counter'; // Adjust the path as needed

const Statics = () => {
    const [companies, setCompanies] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [offers, setOffers] = useState([]);
    const [projects, setProjects] = useState([]);

    useEffect(() => {
        fetch(api_url + '/api/companies')
            .then(response => response.json())
            .then(data => {
                // Log the fetched data for debugging
                setCompanies(data?.data);
            })
            .catch(error => console.error('Error fetching data:', error));
    }, []);

    useEffect(() => {
        fetch(api_url + '/api/customers')
            .then(response => response.json())
            .then(data => {
                // Log the fetched data for debugging
                setCustomers(data?.data);
            })
            .catch(error => console.error('Error fetching data:', error));
    }, []);

    useEffect(() => {
        fetch(api_url + '/api/offers')
            .then(response => response.json())
            .then(data => {
                // Log the fetched data for debugging
                setOffers(data?.data);
            })
            .catch(error => console.error('Error fetching data:', error));
    }, []);

    useEffect(() => {
        fetch(api_url + '/api/projects')
            .then(response => response.json())
            .then(data => {
                // Log the fetched data for debugging
                setProjects(data?.data);
            })
            .catch(error => console.error('Error fetching data:', error));
    }, []);

    return (
        <div className="aon-statics-blocks">
            <div className="row">
                {/*Block 1*/}
                <div className="col-lg-6 m-b30 aon-static-position-1">
                    <div className="media-bg-animate media-statics aon-icon-effect">
                        <div className="aon-static-section aon-t-blue">
                            <div className="aon-company-static-num counter aon-icon">
                                <Counter end={companies.length} />
                            </div>
                            <div className="aon-company-static-name">Providers</div>
                        </div>
                    </div>
                    <div className="media-bg-animate media-statics aon-icon-effect">
                        <div className="aon-static-section aon-t-yellow">
                            <div className="aon-company-static-num counter aon-icon">
                                <Counter end={offers.length} />
                            </div>
                            <div className="aon-company-static-name">Special Offers</div>
                        </div>
                    </div>
                </div>
                {/*Block 2*/}
                <div className="col-lg-6 m-b30 aon-static-position-2">
                    <div className="media-bg-animate media-statics aon-icon-effect">
                        <div className="aon-static-section aon-t-green">
                            <div className="aon-company-static-num counter aon-icon">
                                <Counter end={customers.length} />
                            </div>
                            <div className="aon-company-static-name">Customer</div>
                        </div>
                    </div>
                    <div className="media-bg-animate media-statics aon-icon-effect">
                        <div className="aon-static-section aon-t-skyblue">
                            <div className="aon-company-static-num counter aon-icon">
                                <Counter end={projects.length} />
                            </div>
                            <div className="aon-company-static-name">Experiences Projects</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Statics;
